import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import SectionMessage from '@atlaskit/section-message';

import { messages } from '../../messages';

export const TransitionToGicAnywhereSectionMessage = () => {
	return (
		<SectionMessage>
			<FormattedMessage {...messages.transitionToGicAnywhereSectionMessage} />
		</SectionMessage>
	);
};
